export function scrollToElement(element, offsetY = 0) {
  if (element) {
    const elementRect = element.getBoundingClientRect();
    const offsetTop = window.pageYOffset + elementRect.top + offsetY;
    window.scrollTo({
      top: offsetTop,
      behavior: 'smooth',
    });
  }
}

export function scrollToNamedElement(name) {
  if (!name) return;

  const element = document.querySelector(`[name="${name}"]`);
  if (element) scrollToElement(element, -200);
}
